export const STATS = {
  BRIGHTNESS_BG_COMPETITOR_THRESHOLD: 210,

  TOP_STATS_CATEGORY: {
    id: -1,
    name: 'Top Stats'
  },

  WIDGET_TYPES: {
    lmt: "LMT"
  },

  INFO_ICON_SIZE: {
    width: 16,
    height: 16
  },

  MARKED_TEAM: {
    homeCompetitor: 1,
    awayCompetitor: 2
  },

  ACTION_TYPES: {
    fetchHandler: 'fetchHandler',
    displayHandler: 'displayHandler',
    onFilterChange: 'onFilterChange',
    onSeeMoreClick: 'onSeeMoreClick',
    actualPlayTimeDisplayHandler: 'actualPlayTimeDisplayHandler'
  }
};
